<svg width="200" height="200" viewBox="0 0 100 100" class="rainbow-spin">
  <defs>
    <radialGradient id="easterEggGrad" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
      <stop offset="0%" stop-color="#ff6ec4">
        <animate
          attributeName="stop-color"
          values="#ff6ec4;#7873f5;#4ef0d1;#ff6ec4"
          dur="3s"
          repeatCount="indefinite"
        />
      </stop>
      <stop offset="100%" stop-color="#7873f5">
        <animate
          attributeName="stop-color"
          values="#7873f5;#4ef0d1;#ff6ec4;#7873f5"
          dur="3s"
          repeatCount="indefinite"
        />
      </stop>
    </radialGradient>
  </defs>
  <path fill="url(#easterEggGrad)">
    <animate
      attributeName="d"
      dur="10s"
      repeatCount="indefinite"
      values="
        M50,12 C70,8 90,30 88,50 C86,70 70,92 50,88 C30,86 10,70 12,50 C14,30 30,8 50,12 Z;
        M50,10 C72,10 90,28 90,50 C90,72 72,90 50,90 C28,90 10,72 10,50 C10,28 28,10 50,10 Z"
    />
  </path>
  <circle cx="50" cy="50" r="20" fill="url(#easterEggGrad)">
    <animate attributeName="r" values="18;22;18" dur="1.5s" repeatCount="indefinite" />
  </circle>
</svg>
